import React, { FunctionComponent, useEffect, useRef } from "react";

const HOTWTile: FunctionComponent = () => {
	const coinImageRef = useRef(null);

	useEffect(() => {
		if (coinImageRef.current && coinImageRef.current.classList.contains("in-view")) {
			// after 1 second (the duration of the animation), remove the in-view class
			setTimeout(() => {
				coinImageRef.current.classList.remove("in-view");
			}, 1000);
		}
	}, []);

	const handleCoinClick = (e: React.MouseEvent<HTMLButtonElement>) => {
			var videoModal = document.getElementById("hotw-modal");
			const url = new URL(window.location.href);
			url.searchParams.set("homes", "hotw");
			url.searchParams.set("video", "hotw");
			window.history.pushState(null, null, url);
	
			videoModal.setAttribute("style", "display: block");
			document.body.classList.add("modal-open");
		}

	return (
		<div className="hotw-title-tile">
			<div className="hotw-banner">
				<div className="coin-container">
					<button aria-label="Watch video about homes of the week" className="hotw-wrapper hotw-tile" onClick={(e) => handleCoinClick(e)}>
						<img 
							alt=""
							ref={coinImageRef} 
							className="hotw-coin in-view" 
							src="/-/media/hotw_coin_flat.png"
							onMouseEnter={() => {
								if (coinImageRef.current) {
                        			coinImageRef.current.classList.add("in-view");
                    			}
								// after 1 second (the duration of the animation), remove the in-view class
								setTimeout(() => {
									if (coinImageRef.current && coinImageRef.current.classList.contains("in-view")) {
										coinImageRef.current.classList.remove("in-view");
									}
								}, 1000);
							}}
						/>
						<div className="hotw-coin-shadow"></div>
					</button>
				</div>
				<div className="hotw-banner-descr">
					<h2>Homes of the week</h2>
					<p>Our favorite house can be your new home. Schedule a tour today.</p>
				</div>
			</div>
		</div>
    );
};

export default HOTWTile;